import axios from "axios";
import React, { Component } from "react";
import Scrollspy from "react-scrollspy";
import Countdown from "react-countdown";
import { Helmet } from "react-helmet";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AudioWedding from "./components/AudioWedding";
import VolumeButton from "./components/VolumeButton";
import LoadingScreen from "./components/LoadingScreen";
import SweetAlert from "react-bootstrap-sweetalert";

import moment from "moment";
require("moment/locale/id");

class WeddingV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wedding: {},
      undangan: {},
      muted: false,
      isReady: false,
      alert: null,
      tanggal: "2021-06-24",
    };
    this.handleMute = this.handleMute.bind(this);
  }

  componentDidMount() {
    const wedUsername = this.props.match.params.username;
    axios.get(`${window.localhost}/wedding/${wedUsername}`).then((response) => {
      this.setState({
        wedding: response.data,
      });

      // Undangan
      if (this.props.match.params.permalink) {
        const wedPermalink = this.props.match.params.permalink;
        axios
          .get(`${window.localhost}/getundangan/${wedUsername}/${wedPermalink}`)
          .then((response) => {
            this.setState({
              undangan: response.data,
            });
            if (response.data) {
              setTimeout(() => this.showUndangan(), 3000);
            }
          });
      }
      setTimeout(
        () =>
          this.setState({
            isReady: true,
          }),
        2000
      );
    });
  }

  showUndangan() {
    const { undangan, wedding } = this.state;
    const tanggal = moment(wedding.tanggal, "YYYY-MM-DD").format("DD");
    const bulan = moment(wedding.tanggal, "YYYY-MM-DD").format("MMMM");
    const tahun = moment(wedding.tanggal, "YYYY-MM-DD").format("YYYY");
    const getAlert = () => (
      <SweetAlert
        title=""
        confirmBtnText="Close"
        confirmBtnBsStyle="default"
        btnSize="xs"
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        focusConfirmBtn
        showCloseButton={true}
        customClass="w-md-75 w-100 pt-5 px-0"
      >
        <div
          className="bg-undangan"
          style={{
            backgroundImage: `url(/img/aset-undangan-atas.png), url(/img/aset-undangan-bawah.png)`,
          }}
        >
          <span className="display-2 font-great-vibes">
            {wedding.namesuami} & {wedding.nameistri}
          </span>
          <hr className="col-md-6 col-8 mx-auto" />
          <p className="font-poppins">Assalamu alaikum wr. wb.</p>
          <p className="font-poppins">Kepada Yth. Bapak/Ibu/Saudara/i:</p>
          <h2 className="font-libre badge bg-light text-dark px-4 fs-3">
            {undangan.fullname}
          </h2>
          <p className="col-10 mx-auto font-poppins">
            Dengan memohon rahmat & ridho Allah Swt. kami bermaksud
            menyelenggarakan akad nikah & resepsi pernikahan yang insyaAllah
            akan dilaksanakan pada:
          </p>
          <h2 className="font-libre badge bg-light text-dark px-4 fs-3">
            {tanggal} {bulan} {tahun}
          </h2>
          <p className="font-poppins">Lokasi:</p>
          <p className="col-10 bg-light rounded-1 py-2 mx-auto font-libre px-4 mt-3">
            {wedding.desclokasi}
          </p>
          <p className="col-10 mx-auto font-poppins">
            Merupakan kehormatan bagi kami apabila {undangan.panggilan} berkenan
            hadir di acara kami. Atas kehadiran dan doa restunya, kami ucapkan
            terima kasih.
          </p>
          <p className="font-poppins">Wassalamu alaikum wr. wb.</p>
        </div>
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleMute() {
    if (this.state.muted) {
      this.setState({
        muted: false,
      });
    } else {
      this.setState({
        muted: true,
      });
    }
  }

  scriptJs() {
    // NAVBAR EFFECT
    window.onscroll = function () {
      myNavbar();
    };
    function myNavbar() {
      var x = document.getElementById("myNav");
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        x.classList.add("shadow-nav");
      } else {
        x.classList.remove("shadow-nav");
      }
    }
    // END NAVBAR EFFECT
  }

  render() {
    const { wedding } = this.state;
    const imgpath = `${window.localhost}/img/`;
    const musicpath = `${window.localhost}/music/`;

    const tanggal = moment(wedding.tanggal, "YYYY-MM-DD").format("DD");
    const bulan = moment(wedding.tanggal, "YYYY-MM-DD").format("MMMM");
    const tahun = moment(wedding.tanggal, "YYYY-MM-DD").format("YYYY");

    const date_lengkap = moment(wedding.tanggal, "YYYY-MM-DD").format(
      "DD MMMM YYYY"
    );

    const hmin = moment(wedding.tanggal, "YYYY-MM-DD").diff(moment(), "days");

    // Random component
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
      if (completed) {
        // Render a completed state
        return <Completionist />;
      } else {
        // Render a countdown
        return (
          <div className="row row-cols-1 row-cols-md-4 text-center pt-4">
            <div className="col font-petit">
              <h3 className="display-3 text-brown">{hmin}</h3>
              <p className="">Days</p>
            </div>
            <div className="col font-petit">
              <h3 className="display-3 text-brown">{hours}</h3>
              <p className="">Hours</p>
            </div>
            <div className="col font-petit">
              <h3 className="display-3 text-brown">{minutes}</h3>
              <p className="">Minutes</p>
            </div>
            <div className="col font-petit">
              <h3 className="display-3 text-brown">{seconds}</h3>
              <p className="">Seconds</p>
            </div>
          </div>
        );
      }
    };

    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>Wedding Invitation by CreatifaStudio</title>
            <meta
              name="description"
              content="Wedding Invitation by CreatifaStudio"
            />
          </Helmet>
          <nav
            className="navbar navbar-expand-lg navbar-light sticky-top bg-white py-3 trans-all"
            id="myNav"
          >
            <div className="container d-flex justify-content-between">
              <div className="btn box-outline-brown rounded-0 px-5 py-2">
                <span className="fs-6">
                  {wedding.namesuami} & {wedding.nameistri}
                </span>
              </div>

              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
                className="btn box-outline-brown d-md-none d-flex"
              >
                <FontAwesomeIcon icon={faBars} />
              </button>

              <Scrollspy
                items={[
                  "section1",
                  "section2",
                  "section3",
                  "section4",
                  "section5",
                  "section6",
                ]}
                offset={0}
                currentClassName="is-active"
                className="nav nav-pills d-md-flex  d-none"
              >
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section2">
                    Countdown
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section3">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section4">
                    Gallery
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section5">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section6">
                    Contact
                  </a>
                </li>
              </Scrollspy>
            </div>
          </nav>

          <div
            className="offcanvas offcanvas-start w-75"
            tabIndex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                {wedding.namesuami} & {wedding.nameistri}
              </h5>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <Scrollspy
                items={[
                  "section1",
                  "section2",
                  "section3",
                  "section4",
                  "section5",
                  "section6",
                ]}
                offset={0}
                currentClassName="is-active"
                className="nav nav-pills d-md-none d-block"
              >
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section2">
                    Countdown
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section3">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section4">
                    Gallery
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section5">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border">
                  <a className="nav-link text-secondary" href="#section6">
                    Contact
                  </a>
                </li>
              </Scrollspy>
            </div>
          </div>

          <div
            id="section1"
            className="container-fluid overflow-hidden px-md-5 px-0"
          >
            <div className="container-fluid">
              <div
                className="full-screen w-100 d-flex align-items-center"
                style={{
                  backgroundImage: `url(${imgpath}/${wedding.username}/${wedding.imgslide1})`,
                }}
              >
                <div className="overlay-color-white"></div>
                <div className="circle-container mx-auto text-center py-5 px-md-5 px-4 text-light">
                  <div className="d-flex align-items-center h-100">
                    <div className="row">
                      <span className="mb-4">
                        {tanggal} {bulan} {tahun}
                      </span>
                      <h3 className="fs-2 font-petit mb-4">
                        {wedding.namesuami} & {wedding.nameistri} Wedding
                        Ceremony
                      </h3>
                      <span className="fs-5 mb-4 font-petit">
                        {wedding.descheader}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="section2" className="bg-white">
            <img
              className="img-decr-end d-md-flex d-none"
              src="https://preview.colorlib.com/theme/sunshine/img/banner/flower-top.png.webp"
            />
            <div className="container wrapper-sm">
              <div className="row">
                <div className="col-12 text-center">
                  <img
                    src="https://preview.colorlib.com/theme/sunshine/img/banner/xflowers.png.pagespeed.ic.8zqoNOVS7w.webp"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="row py-4 text-center">
                <p className="font-mulish fs-5 text-brown">24 Juni 2021</p>
                <p className="fs-1">THE WEDDING COUNTDOWN</p>
              </div>
              <div className="row">
                <div
                  className="container full-bg py-5 px-5"
                  style={{
                    backgroundImage: `url(https://preview.colorlib.com/theme/sunshine/img/counter_bg/xcounter_bg.png.pagespeed.ic.UElvKGGD0-.webp)`,
                  }}
                >
                  <div className="bg-white">
                    <div className="count-down fs-4">
                      <Countdown date={date_lengkap} renderer={renderer} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="section3">
            <img
              className="img-decr-start d-md-flex d-none"
              src="https://preview.colorlib.com/theme/sunshine/img/banner/flower-bottom.png.webp"
            />
            <div className="container wrapper-sm">
              <div className="row">
                <div className="col-12 text-center">
                  <img
                    src="https://preview.colorlib.com/theme/sunshine/img/banner/xflowers.png.pagespeed.ic.8zqoNOVS7w.webp"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="row text-center">
                <p className="fs-1">{wedding.title2}</p>
              </div>
              <div className="row row-cols-md-3 row-cols-1 mt-4">
                <div className="col my-3 text-center">
                  <div
                    className="full-bg img-pasutri"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgsuami})`,
                    }}
                  ></div>
                  <div className="font-petit py-3">
                    <h3>Groom</h3>
                    <h2 className="text-brown">{wedding.fullnamesuami}</h2>
                    <p className="text-desc2 mt-4">{wedding.descsuami}</p>
                  </div>
                </div>
                <div className="col my-3 px-3">
                  <div className="h-100 w-100 bg-divider text-center px-4">
                    <p className="font-petit h-100 text-brown fs-4 d-flex align-items-center">
                      {wedding.desc2}
                    </p>
                  </div>
                </div>
                <div className="col my-3 text-center">
                  <div
                    className="full-bg img-pasutri"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgistri})`,
                    }}
                  ></div>
                  <div className="font-petit py-3">
                    <h3>Bride</h3>
                    <h2 className="text-brown">{wedding.fullnameistri}</h2>
                    <p className="text-desc2 mt-4">{wedding.descistri}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="section4">
            <div className="container-fluid px-4">
              <div className="row">
                <div className="col-12 text-center">
                  <img
                    src="https://preview.colorlib.com/theme/sunshine/img/banner/xflowers.png.pagespeed.ic.8zqoNOVS7w.webp"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="row text-center">
                <p className="fs-1">GALLERY PHOTOS</p>
              </div>
              <div className="row mt-4">
                <div className="col-md-4 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide1})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-3 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide2})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-5 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide3})`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imglokasi})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-5 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgakad})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-4 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgresepsi})`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div id="section5">
            <div className="container wrapper-sm">
              <div className="row">
                <div className="col-12 text-center">
                  <img
                    src="https://preview.colorlib.com/theme/sunshine/img/banner/xflowers.png.pagespeed.ic.8zqoNOVS7w.webp"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="row text-center">
                <p className="fs-1">EVENT DETAILS</p>
              </div>
              <div className="row row-cols-md-3 row-cols-1 g-4 mt-4">
                <div className="col">
                  <div
                    className="py-4 px-3 full-bg h-100"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imglokasi})`,
                    }}
                  >
                    <div className="card h-100">
                      <div className="card-body text-center py-5">
                        <h5 className="card-title text-brown">Lokasi</h5>
                        <p className="card-text text-secondary">
                          {wedding.desclokasi}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div
                    className="py-4 px-3 full-bg h-100"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgakad})`,
                    }}
                  >
                    <div className="card h-100">
                      <div className="card-body text-center py-5">
                        <h5 className="card-title text-brown">Akad Nikah</h5>
                        <p className="card-text text-secondary">
                          {wedding.descakad}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div
                    className="py-4 px-3 full-bg h-100"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgresepsi})`,
                    }}
                  >
                    <div className="card h-100">
                      <div className="card-body text-center py-5">
                        <h5 className="card-title text-brown">Resepsi</h5>
                        <p className="card-text text-secondary">
                          {wedding.descresepsi}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="section6">
            <div className="container my-5">
              <div className="row">
                <div className="col-md-8 col-10 mx-auto">
                  <img
                    className="img-contact-top d-md-flex d-none"
                    src="https://preview.colorlib.com/theme/sunshine/img/banner/flower-bottom.png.webp"
                  />
                  <img
                    className="img-contact-bottom d-md-flex d-none"
                    src="https://preview.colorlib.com/theme/sunshine/img/banner/flower-bottom.png.webp"
                  />
                  <div className="card bg-white border-0 shadow">
                    <div className="card-body text-center py-5">
                      <h2 className="card-title text-brown font-petit">
                        {wedding.title4}
                      </h2>
                      <p className="card-text text-secondary px-md-5 px-3">
                        {wedding.desc4}
                      </p>
                      <a
                        href={`http://api.whatsapp.com/send/?phone=${wedding.nohp}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn box-outline-brown rounded-0 px-5 py-2"
                      >
                        Contact Us!
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer>
            <div className="container-fluid bg-divider">
              <div className="row py-4">
                <ul className="nav justify-content-center text-center">
                  <li className="nav-item nav-item-border">
                    <a className="nav-link text-secondary" href="#section1">
                      Home
                    </a>
                  </li>
                  <li className="nav-item nav-item-border">
                    <a className="nav-link text-secondary" href="#section2">
                      Countdown
                    </a>
                  </li>
                  <li className="nav-item nav-item-border">
                    <a className="nav-link text-secondary" href="#section3">
                      Our Story
                    </a>
                  </li>
                  <li className="nav-item nav-item-border">
                    <a className="nav-link text-secondary" href="#section4">
                      Gallery
                    </a>
                  </li>
                  <li className="nav-item nav-item-border">
                    <a className="nav-link text-secondary" href="#section5">
                      Event
                    </a>
                  </li>
                  <li className="nav-item nav-item-border">
                    <a className="nav-link text-secondary" href="#section6">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <AudioWedding
              muted={this.state.muted}
              musicurl={`${musicpath}/${wedding.youtubecode}`}
            />
            <VolumeButton
              handleMute={this.handleMute}
              muted={this.state.muted}
            />
            <div className="container-fluid pt-3 pb-1 w-100 bg-white">
              <p className="text-center">
                Crafted with ❤️ by{" "}
                <a
                  href="creatifastudio.com"
                  className="text-dark text-decoration-none"
                >
                  CreatifaStudio
                </a>
              </p>
            </div>
          </footer>
          {this.state.alert}
          {this.scriptJs()}
        </div>
      );
    }
  }
}

export default WeddingV2;
